import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ContactSourceContainerModel} from '../../../../../../models/aggregates/crm/contact';

@Injectable({providedIn: 'root'})
export class ContactSourceService extends BaseApiTemplateService<ContactSourceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contact-sources';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contact-sources';
    this.httpClient = http;
  }

}
